export class SurveyResponseModel {
  public id: number = 0;
  public merchant_id: number = 0;
  public survey_type: string = '';
  public question: string = '';
  public answer: string = '';
  public answer_label: string = '';
  public free_text: string = '';
  public feature_code: string = '';
  public createdAt: string = '';

  public mapData(data: any = {}) {
    this.id = data.id;
    this.merchant_id = data.merchant_id;
    this.survey_type = data.survey_type;
    this.question = data.question;
    this.answer = data.answer;
    this.answer_label = data.answer_label || data.answer;
    this.free_text = data.free_text || '';
    this.feature_code = data.feature_code || '';
    this.createdAt = data.createdAt;
  }
}
